import { QcropModel } from '../model/qcrop.model';

export function transformQcrop(qcrop: QcropModel): QcropModel {
  return {
    ...qcrop,
    templates: qcrop.templates.map(template => ({
      ...template,
      visible: true,
    })),
    focalPoints: qcrop.focalPoints.map(focalPoint => ({
      ...focalPoint,
      visible: true,
    })),
  };
}
